export const LOGOUT = "LOGOUT";
export const SET_LOADER = "SET_LOADER";
export const SET_SHOW_COMMON_MODAL = "SET_SHOW_COMMON_MODAL";
export const SET_SHOW_COMMON_MODAL_CONTENT = "SET_SHOW_COMMON_MODAL_CONTENT";
export const SET_LANGUAGE = "SET_LANGUAGE";

